/**
 * SMS History — mounted at /app/maud-erp/sms-history.
 * Who may open it is decided by the menu grant, checked again by the server.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const SmsHistory = lazy(() => import('../pages/SmsHistory'));

export const smsHistoryRoutes: RouteObject[] = [
  { index: true, element: <SmsHistory /> },
];

export default smsHistoryRoutes;
